import { createTheme, InputLabel, styled, ThemeProvider } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { IEFInputLabelProps } from './EFInputLabel.model'

const CustomInputLabel = styled(InputLabel)(({ theme }) => ({
  marginBottom: '0.5rem',
  display: 'block',
  color: theme.palette.mode === 'dark' ? 'var(--white)' : 'var(--dark)'
}))

export const EFInputLabel = ({ name, label, style, children }: IEFInputLabelProps) => {
  const theme = useAppSelector(currentTheme)
  const customTheme = createTheme({
    palette: {
      mode: theme
    }
  })
  return (
    <ThemeProvider theme={customTheme}>
      <CustomInputLabel
        htmlFor={name}
        style={{ ...style }}
      >
        {label}
        {children}
      </CustomInputLabel>
    </ThemeProvider>
  )
}
